// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"5af7b87f","371":"fe879cab"}[chunkId] + ".chunk.js";
};